/*
 * @Author: your name
 * @Date: 2021-12-20 13:47:42
 * @LastEditTime: 2021-12-20 13:48:57
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gw-react\src\utils\request.js
 */
import axios from "axios";

//1.创建axios实例，默认配置也可以在具体请求内复写修改。
const request = axios.create({
  // 覆写库的超时默认值
  // 现在，在超时前，所有请求都会等待 5 秒
  timeout: 50000,

  //apibaseURL设置
  baseURL: process.env.REACT_APP_BASE_URL,
});

// 2.添加请求拦截器
request.interceptors.request.use(
  (request) => {
    // 在发送请求之前做些什么

    /**
     * 添加权限验证
        const user: any = true;
        if (user) {
        request.headers = {
            ...request.headers,
            Authorization: user,
        };
        }
     */
    return request;
  },
  (error) => {
    // 对请求错误做些什么(转到错误页面之类的)
    return Promise.reject(error);
  }
);

// 3.添加响应拦截器
request.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    /**
     * 对特定api进行操作
     * if (response.config.url == '/api/auth/getCode') {
        return response;
      }
     */

    //对一些特定的后端指定错误进行页面跳转（比如权限验证等的）

    //返回data使用时只关注数据
    return response.data;
  },
  (error) => {
    // 对响应错误做点什么（转到错误页面之类的）
    return Promise.reject(error);
  }
);

export default request;
